<template>
  <div>
    <v-dialog v-model="dialog" max-width="800px">
      <template v-slot:activator="{ on }">
        <v-btn v-on="on" color="primary" class="text-capitalize font-weight-bold">
          Settings
        </v-btn>
      </template>
      <v-card class="pa-3">
        <v-card-title>
          <span class="text-h6 dark--text"> Settings</span>
          <v-spacer></v-spacer>
          <v-btn color="primary" class="light--text" text @click="close"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-form class="pa-sm-8 mt-n6" @submit="updateConfigurations()" v-model="valid" ref="form">
          <v-card-text>
            <v-container>
              <!-- {{ splashScreenContent }} -->

              <v-layout wrap>
                <v-flex xs12 sm4 md3 lg3 class="mt-n6 mt-sm-2"> Enable/Disable</v-flex>
                <v-flex xs12 sm8 md9 lg3 class="mt-n2">
                  <v-checkbox v-model="isFreezeActive" label=" Freeze"> Freeze</v-checkbox>
                </v-flex>
                <v-flex xs12 sm8 md9 lg2 class="mt-n2">
                  <v-checkbox v-model="isShopActive" label=" Shop"> Shop</v-checkbox>
                </v-flex>
                <v-flex xs12 sm8 md9 lg4 class="mt-1" v-if="isShopActive">
                  <v-select placeholder="Shopping app view" :items="['ListView', 'GridView']" v-model="shoppingView" solo chips label="Shopping - App View" dense></v-select>
                </v-flex>
              </v-layout>

              <v-layout>
                <v-flex>
                  <v-layout wrap v-if="isShopActive">
                    <v-flex xs12 sm4 md3 lg3 class="mt-n4 mt-sm-2">
                      <h4 class="font-weight-medium">Delivery Charge</h4>
                    </v-flex>
                    <v-flex xs12 sm8 md9 lg3>
                      <v-text-field label="Delivery Charge" v-model="deliveryCharge" solo type="number" dense></v-text-field>
                    </v-flex>
                  </v-layout>

                  <v-layout wrap>
                    <v-flex xs12 sm4 md3 lg3 class="mt-n4 mt-sm-2">
                      <h4 class="font-weight-medium">Freeze Max Days</h4>
                    </v-flex>
                    <v-flex xs12 sm8 md9 lg3>
                      <v-text-field label="Freeze Max Days" v-model="freezeMaxDays" solo type="number" dense></v-text-field>
                    </v-flex>
                  </v-layout>

                  <v-layout wrap>
                    <v-flex xs12 sm4 md3 lg3 class="mt-n4 mt-sm-2">
                      <h4 class="font-weight-medium">Freeze Min Days</h4>
                    </v-flex>
                    <v-flex xs12 sm8 md9 lg3>
                      <v-text-field label="Freeze Min Days" v-model="freezeMinDays" type="number" solo dense></v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-layout wrap>
                    <v-flex xs12 sm4 md3 lg3 class="mt-n4 mt-sm-2">
                      <h4 class="font-weight-medium">Freeze Upto Days</h4>
                    </v-flex>
                    <v-flex xs12 sm8 md9 lg3>
                      <v-text-field label="Freeze Upto Days" v-model="freezeUpToDays" type="number" solo dense></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex v-if="isShopActive">
                  <v-layout wrap>
                    <v-flex xs12 sm4 md3 lg3 class="mt-n4 mt-sm-2">
                      <h4 class="font-weight-medium">Store On/Off</h4>
                    </v-flex>
                    <v-flex xs12 sm8 md9 lg3>
                      <v-switch v-model="isStoreOn" class="mt-5"></v-switch>
                    </v-flex>
                  </v-layout>
                  <v-layout wrap>
                    <v-flex xs12 sm4 md3 lg3 class="mt-n4 mt-sm-2">
                      <h4 class="font-weight-medium">Store On Time</h4>
                    </v-flex>
                    <v-flex>
                      <div>
                        <v-text-field outlined dense label="Start Time" type="time" v-model="storeOnTime"></v-text-field>
                      </div>
                    </v-flex>
                  </v-layout>
                  <v-layout wrap>
                    <v-flex xs12 sm4 md3 lg3 class="mt-n4 mt-sm-2">
                      <h4 class="font-weight-medium">Store Off Time</h4>
                    </v-flex>
                    <v-flex>
                      <div>
                        <v-text-field outlined dense label="End Time" type="time" v-model="storeOffTime"></v-text-field>
                      </div>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions class="mb-sm-n4">
            <!-- <v-spacer></v-spacer> -->
            <v-layout justify-center>
              <v-btn color="primary" class="light--text" :width="$vuetify.breakpoint.smAndUp ? 120 : 90" :loading="btnloading" @click="updateConfigurations" :disabled="!valid">Save</v-btn>
            </v-layout>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
    <v-snackbar v-model="snackbar" timeout="3000" right top :color="color">{{ text }}</v-snackbar>
    <v-snackbar v-model="snackbarError" timeout="3000" right top color="error">{{ text }}</v-snackbar>
  </div>
</template>

<script>
import { requiredValidator } from "../../core/methods/validations";
export default {
  data() {
    return {
      requiredValidator: requiredValidator,
      dialog: false,
      snackbarError: false,
      btnloading: false,
      color: "success",
      snackbar: false,
      text: "",
      valid: true,
      freezeMinDays: "",
      freezeMaxDays: "",
      freezeUpToDays: "",
      shoppingView: "",
      isFreezeActive: false,
      isShopActive: false,
      isStoreOn: true,
      storeOnTime: "",
      storeOffTime: "",
    };
  },
  apollo: {
    getAppConfigurations() {
      return {
        query: require("../api/getAppConfigurations.graphql"),
        result({ data, loading }) {
          this.loading = loading;
          this.freezeMaxDays = data.getAppConfigurations.freezeMaxDays;
          this.freezeMinDays = data.getAppConfigurations.freezeMinDays;
          this.freezeUpToDays = data.getAppConfigurations.freezeUpToDays;
          this.isFreezeActive = data.getAppConfigurations.isFreezeActive;
          this.isShopActive = data.getAppConfigurations.isShopActive;
          this.shoppingView = data.getAppConfigurations.shoppingView;
          this.deliveryCharge = data.getAppConfigurations.deliveryCharge;
          this.isStoreOn = data.getAppConfigurations.isStoreOn;
          this.storeOnTime = data.getAppConfigurations.storeOnTime;
          this.storeOffTime = data.getAppConfigurations.storeOffTime;
        },
      };
    },
  },
  methods: {
    updateConfigurations() {
      this.btnloading = true;
      this.$apollo
        .mutate({
          mutation: require("../api/updateConfigurations.graphql"),
          variables: {
            freezeMaxDays: parseInt(this.freezeMaxDays),
            freezeMinDays: parseInt(this.freezeMinDays),
            freezeUpToDays: parseInt(this.freezeUpToDays),
            isFreezeActive: this.isFreezeActive,
            isShopActive: this.isShopActive,
            shoppingView: this.shoppingView,
            deliveryCharge: parseFloat(this.deliveryCharge),
            isStoreOn: this.isStoreOn,
            storeOnTime: this.storeOnTime,
            storeOffTime: this.storeOffTime,
          },
          update: () => {
            try {
              // this.$root.$emit("updateBlock");
              this.color = "success";
              this.text = "Freeze Settings Updated";
              this.snackbar = true;
            } catch (e) {
              console.log(e);
              console.log("Something bad happend");
            }
            this.btnloading = false;
            this.dialog = false;
          },
        })
        .catch(error => {
          this.btnloading = false;
          this.text = error;
          this.color = "error";
          this.snackbarError = true;

          console.log(error);
        });
    },
    close() {
      this.dialog = false;
    },
  },
};
</script>
